import {cva} from 'class-variance-authority'

// v3 "filled" field: bottom-border only, top corners rounded, mint fill.
export const inputTextFieldVariants = cva(
  'flex w-full items-center gap-2 rounded-t-[4px] border-b border-solid px-3 py-2 transition-colors focus-within:border-primary',
)

export const inputIconWrapperClass =
  'flex shrink-0 items-center justify-center min-w-6 min-h-6 whitespace-nowrap text-text-secondary [&_svg]:size-6'

// `h-10` matches the 40px inner row the Figma field specifies in every state
// (`h-[40px]` when empty, 16px label + 24px input once filled), making the box
// `8 + 40 + 8`. Without it the row collapsed to the 24px line height and the
// field came out ~40px instead of 56 — and a different height from native.
//
// The value is `text/primary` in every enabled state — Figma's Complete, Active
// and Error fields all paint it so, and `TextField` already does. It used to
// rest in `text/secondary` and only darken on focus, which left a filled,
// blurred field visibly lighter than the `TextField` beside it.
export const inputBaseClass =
  'h-10 flex-1 bg-transparent outline-none text-base font-semibold text-text-primary placeholder:text-text-disabled disabled:text-text-disabled'

/**
 * Resolves the filled box's state classes — default, error, disabled. Focus is
 * handled by `focus-within:` in the base variant, so it is not a state here.
 *
 * Extracted from the component so its body stays under the repo's complexity
 * budget, and so the states live next to the class they modify.
 */
export function inputBoxClass({
  isError,
  disabled,
}: {
  isError?: boolean
  disabled?: boolean
}): string[] {
  return [
    inputTextFieldVariants(),
    'bg-[#f6f9f8] border-divider',
    isError ? 'border-error bg-[rgba(255,128,140,0.16)]' : '',
    disabled ? 'bg-action-disabled-background border-divider' : '',
  ]
}
